/* =========================================================================
   boleta-factura.js  —  carrito Shopify con Boleta/Factura (Chile)
   - Valida RUT (módulo 11 con dígito K)
   - Valida email
   - Region → Comuna dependientes
   - Guarda todo como cart attributes  →  note_attributes  →  metafields
   ------------------------------------------------------------------------- */

(() => {
  'use strict';

  const COD_DTE = {
    Boleta:  39,
    Factura: 33
  };

  // ---------------------------------------------------------------------
  // 1) Validador de RUT (módulo 11)
  // ---------------------------------------------------------------------
  function checkRut(input) {
    let valor = input.value.replace(/\./g, '').replace(/-/g, '');
    const cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    input.value = cuerpo + '-' + dv;
    if (cuerpo.length < 7) return false;

    let suma = 0;
    let multiplo = 2;
    for (let i = 1; i <= cuerpo.length; i++) {
      suma += multiplo * parseInt(valor.charAt(cuerpo.length - i), 10);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }
    let dvEsperado = 11 - (suma % 11);
    let dvNum = dv === 'K' ? 10 : (dv === '0' ? 11 : parseInt(dv, 10));
    return dvEsperado === dvNum;
  }

  // ---------------------------------------------------------------------
  // 2) Validador de email
  // ---------------------------------------------------------------------
  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // ---------------------------------------------------------------------
  // 3) Dataset oficial regiones / comunas de Chile (códigos ISO 3166-2:CL)
  // ---------------------------------------------------------------------
  const regionesComunas = [
    { regionCode: 'AP', regionName: 'Arica y Parinacota', comunas: ['Arica','Camarones','General Lagos','Putre'] },
    { regionCode: 'TA', regionName: 'Tarapacá', comunas: ['Alto Hospicio','Camiña','Colchane','Huara','Iquique','Pica','Pozo Almonte'] },
    { regionCode: 'AN', regionName: 'Antofagasta', comunas: ['Antofagasta','Calama','María Elena','Mejillones','Ollagüe','San Pedro de Atacama','Sierra Gorda','Taltal','Tocopilla'] },
    { regionCode: 'AT', regionName: 'Atacama', comunas: ['Alto del Carmen','Caldera','Chañaral','Copiapó','Diego de Almagro','Freirina','Huasco','Tierra Amarilla','Vallenar'] },
    { regionCode: 'CO', regionName: 'Coquimbo', comunas: ['Andacollo','Canela','Combarbalá','Coquimbo','Illapel','La Higuera','La Serena','Los Vilos','Monte Patria','Ovalle','Paiguano','Punitaqui','Río Hurtado','Salamanca','Vicuña'] },
    { regionCode: 'VS', regionName: 'Valparaíso', comunas: ['Algarrobo','Cabildo','Calera','Calle Larga','Cartagena','Casablanca','Catemu','Concón','El Quisco','El Tabo','Hijuelas','Isla de Pascua','Juan Fernández','La Cruz','La Ligua','Limache','Llaillay','Los Andes','Nogales','Olmué','Panquehue','Papudo','Petorca','Puchuncaví','Putaendo','Quillota','Quilpué','Quintero','Rinconada','San Antonio','San Esteban','San Felipe','Santa María','Santo Domingo','Valparaíso','Villa Alemana','Viña del Mar','Zapallar'] },
    { regionCode: 'RM', regionName: 'Metropolitana de Santiago', comunas: ['Alhué','Buin','Calera de Tango','Cerrillos','Cerro Navia','Colina','Conchalí','Curacaví','El Bosque','El Monte','Estación Central','Huechuraba','Independencia','Isla de Maipo','La Cisterna','La Florida','La Granja','La Pintana','La Reina','Lampa','Las Condes','Lo Barnechea','Lo Espejo','Lo Prado','Macul','Maipú','María Pinto','Melipilla','Ñuñoa','Padre Hurtado','Paine','Pedro Aguirre Cerda','Peñaflor','Peñalolén','Pirque','Providencia','Pudahuel','Puente Alto','Quilicura','Quinta Normal','Recoleta','Renca','San Bernardo','San Joaquín','San José de Maipo','San Miguel','San Pedro','San Ramón','Santiago','Talagante','Tiltil','Vitacura'] },
    { regionCode: 'LI', regionName: "Libertador General Bernardo O'Higgins", comunas: ['Chépica','Chimbarongo','Codegua','Coinco','Coltauco','Doñihue','Graneros','La Estrella','Las Cabras','Litueche','Lolol','Machalí','Malloa','Marchihue','Mostazal','Nancagua','Navidad','Olivar','Palmilla','Paredones','Peralillo','Peumo','Pichidegua','Pichilemu','Placilla','Pumanque','Quinta de Tilcoco','Rancagua','Rengo','Requínoa','San Fernando','San Vicente','Santa Cruz'] },
    { regionCode: 'ML', regionName: 'Maule', comunas: ['Cauquenes','Chanco','Colbún','Constitución','Curepto','Curicó','Empedrado','Hualañé','Licantén','Linares','Longaví','Maule','Molina','Parral','Pelarco','Pelluhue','Pencahue','Rauco','Retiro','Río Claro','Romeral','Sagrada Familia','San Clemente','San Javier','San Rafael','Talca','Teno','Vichuquén','Villa Alegre','Yerbas Buenas'] },
    { regionCode: 'NB', regionName: 'Ñuble', comunas: ['Bulnes','Chillán','Chillán Viejo','Cobquecura','Coelemu','Coihueco','El Carmen','Ninhue','Ñiquén','Pemuco','Pinto','Portezuelo','Quillón','Quirihue','Ránquil','San Carlos','San Fabián','San Ignacio','San Nicolás','Treguaco','Yungay'] },
    { regionCode: 'BI', regionName: 'Biobío', comunas: ['Alto Biobío','Antuco','Arauco','Cabrero','Cañete','Chiguayante','Concepción','Contulmo','Coronel','Curanilahue','Florida','Hualpén','Hualqui','Laja','Lebu','Los Álamos','Los Ángeles','Lota','Mulchén','Nacimiento','Negrete','Penco','Quilaco','Quilleco','San Pedro de la Paz','San Rosendo','Santa Bárbara','Santa Juana','Talcahuano','Tirúa','Tomé','Tucapel','Yumbel'] },
    { regionCode: 'AR', regionName: 'La Araucanía', comunas: ['Angol','Carahue','Cholchol','Collipulli','Cunco','Curacautín','Curarrehue','Ercilla','Freire','Galvarino','Gorbea','Lautaro','Loncoche','Lonquimay','Los Sauces','Lumaco','Melipeuco','Nueva Imperial','Padre Las Casas','Perquenco','Pitrufquén','Pucón','Purén','Renaico','Saavedra','Temuco','Teodoro Schmidt','Toltén','Traiguén','Victoria','Vilcún','Villarrica'] },
    { regionCode: 'LR', regionName: 'Los Ríos', comunas: ['Corral','Futrono','La Unión','Lago Ranco','Lanco','Los Lagos','Máfil','Mariquina','Paillaco','Panguipulli','Río Bueno','Valdivia'] },
    { regionCode: 'LL', regionName: 'Los Lagos', comunas: ['Ancud','Calbuco','Castro','Chaitén','Chonchi','Cochamó','Curaco de Vélez','Dalcahue','Fresia','Frutillar','Futaleufú','Hualaihué','Llanquihue','Los Muermos','Maullín','Osorno','Palena','Puerto Montt','Puerto Octay','Puerto Varas','Puqueldón','Purranque','Puyehue','Queilén','Quellón','Quemchi','Quinchao','Río Negro','San Juan de la Costa','San Pablo'] },
    { regionCode: 'AI', regionName: 'Aysén del General Carlos Ibáñez del Campo', comunas: ['Aysén','Chile Chico','Cisnes','Cochrane','Coyhaique','Guaitecas','Lago Verde','O’Higgins','Río Ibáñez','Tortel'] },
    { regionCode: 'MA', regionName: 'Magallanes y de la Antártica Chilena', comunas: ['Antártica','Cabo de Hornos','Laguna Blanca','Natales','Porvenir','Primavera','Punta Arenas','Río Verde','San Gregorio','Timaukel','Torres del Paine'] }
  ];

  // ---------------------------------------------------------------------
  // 4) Inicialización (espera a que el DOM tenga el bloque .boleta-factura)
  // ---------------------------------------------------------------------
  const buttonName = 'checkout';

  function init() {
    const root = document.getElementById('boleta-factura');
    if (!root) return false;          // bloque no presente en esta página
    if (root.dataset.bfReady) return true;  // ya inicializado
    root.dataset.bfReady = '1';

    const tabsContainer     = document.getElementById('tabs-container');
    const sectionsContainer = document.getElementById('sections-container');
    const rutInput          = document.getElementById('rutInput');
    const giroInput         = document.getElementById('giroInput');
    const razonSocialInput  = document.getElementById('razonSocialInput');
    const addressInput      = document.getElementById('addressInput');
    const regionInput       = document.getElementById('regionInput');
    const comunaInput       = document.getElementById('comunaInput');
    const emailInput        = document.getElementById('emailInput');

    // Pinta opciones de regiones si el <select> sólo tiene la opción "0"
    if (regionInput && regionInput.options.length <= 1) {
      regionInput.insertAdjacentHTML(
        'beforeend',
        regionesComunas
          .map(r => `<option value="${r.regionCode}">${r.regionName}</option>`)
          .join('')
      );
    }

    // --- Toggle del panel Factura -------------------------------------
    tabsContainer.addEventListener('change', () => {
      const checked = tabsContainer.querySelector('input:checked');
      const codDteInput = document.getElementById('codDteInput');
      if (codDteInput && checked) codDteInput.value = COD_DTE[checked.value] || '';
      if (!checked || checked.value !== 'Factura') {
        sectionsContainer.classList.remove('active');
        return;
      }
      sectionsContainer.classList.add('active');
      rutInput.focus();
    });

    // --- Validador genérico de texto no-vacío (uppercase + .invalid) --
    const textValidation = element => {
      const value = element.value;
      element.value = value.toUpperCase();
      if (value.length === 0) {
        element.parentElement.classList.add('invalid');
        return false;
      }
      element.parentElement.classList.remove('invalid');
      return true;
    };

    // --- RUT: filtro de teclas + validación en vivo -------------------
    rutInput.addEventListener('keydown', e => {
      if (e.key.length === 1 && !/[0-9kK]/.test(e.key)) e.preventDefault();
    });
    rutInput.addEventListener('keyup', () => {
      if (rutInput.value.length === 0 || checkRut(rutInput)) {
        rutInput.parentElement.classList.remove('invalid');
      } else {
        rutInput.parentElement.classList.add('invalid');
      }
    });

    giroInput.addEventListener('keyup',        () => textValidation(giroInput));
    razonSocialInput.addEventListener('keyup', () => textValidation(razonSocialInput));
    addressInput.addEventListener('keyup',     () => textValidation(addressInput));

    emailInput.addEventListener('keyup', () => {
      if (validateEmail(emailInput.value) || emailInput.value.length === 0) {
        emailInput.parentElement.classList.remove('invalid');
      } else {
        emailInput.parentElement.classList.add('invalid');
      }
    });

    // --- Región → Comuna dependiente ----------------------------------
    regionInput.addEventListener('change', e => {
      if (e.target.value === '0') {
        regionInput.parentElement.classList.add('invalid');
        comunaInput.innerHTML = '';
        return;
      }
      regionInput.parentElement.classList.remove('invalid');
      const region = regionesComunas.find(r => r.regionCode === e.target.value);
      if (!region) return;
      comunaInput.innerHTML = region.comunas
        .map(c => `<option value="${c}">${c}</option>`)
        .join('');
    });

    // --- Validación total --------------------------------------------
    const formValidation = () => {
      const checked = tabsContainer.querySelector('input:checked');
      if (!checked) return false;
      if (checked.value !== 'Factura') return true; // Boleta pasa directo

      let valid = true;
      if (!checkRut(rutInput)) {
        rutInput.parentElement.classList.add('invalid');
        rutInput.focus();
        valid = false;
      }
      if (!textValidation(giroInput)        && valid) { giroInput.focus();        valid = false; }
      if (!textValidation(razonSocialInput) && valid) { razonSocialInput.focus(); valid = false; }
      if (!textValidation(addressInput)     && valid) { addressInput.focus();     valid = false; }
      if (regionInput.value === '0') {
        regionInput.parentElement.classList.add('invalid');
        if (valid) regionInput.focus();
        valid = false;
      }
      if (!comunaInput.value) {
        comunaInput.parentElement.classList.add('invalid');
        if (valid) comunaInput.focus();
        valid = false;
      }
      if (!validateEmail(emailInput.value)) {
        emailInput.parentElement.classList.add('invalid');
        if (valid) emailInput.focus();
        valid = false;
      }
      return valid;
    };

    // --- Estado inicial: ocultar Factura y resetear región ------------
    tabsContainer.dispatchEvent(new Event('change'));
    regionInput.value = '0';

    // --- Interceptar TODOS los botones de checkout --------------------
    const wireSendButtons = () => {
      const sendButtons = [...document.querySelectorAll(`[name="${buttonName}"]`)];
      sendButtons.forEach(button => {
        if (button.dataset.bfBound) return;
        button.dataset.bfBound = '1';
        button.addEventListener('click', e => {
          const selected = document.querySelector(
            'input[name="attributes[Boleta/Factura]"]:checked'
          );
          if (!selected) {
            alert('Debe seleccionar boleta o factura');
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          if (formValidation()) return;
          e.preventDefault();
          e.stopPropagation();
        });
      });
    };
    wireSendButtons();

    // Re-vincular si el cart drawer se re-renderiza por AJAX
    const mo = new MutationObserver(() => wireSendButtons());
    mo.observe(document.body, { childList: true, subtree: true });

    return true;
  }

  // Ejecuta init() al cargar y también cuando el drawer aparezca por AJAX
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated',  init);
  document.addEventListener('cart:refresh',  init);
  document.addEventListener('cart:rerender', init);
})();


  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.name || el.name.indexOf('attributes[') !== 0) return;
    if (!el.closest('.boleta-factura--sections')) return;

    var inputs = document.querySelectorAll('.boleta-factura--sections [name^="attributes["]');
    var attributes = {};
    inputs.forEach(function (i) {
      var m = i.name.match(/^attributes\[(.+)\]$/);
      if (!m) return;
      if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
      attributes[m[1]] = i.value;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  });
